import React from 'react';
import {View} from 'react-native';
import animationjson from './home-rebate-animation-config-web';
import {useResponsiveDimensions} from '@/utils';

const HomeRabateAnimationWeb = () => {
  const viewRef = React.useRef(null);
  const {width} = useResponsiveDimensions();
  React.useEffect(() => {
    if (document && viewRef.current) {
      const lottie = require('lottie-web');
      const animation = lottie.loadAnimation({
        container: viewRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationjson,
      });
      return () => {
        animation.destroy();
      };
    }
  }, []);
  return (
    <View
      ref={viewRef}
      style={[
        {
          height: (64 * width) / 375,
          width: (64 * width) / 375,
        },
      ]}
    />
  );
};

export default HomeRabateAnimationWeb;
